<app-validity (onValiditySelected)="dynamicDialogRef.close()"></app-validity>